import React, {
  useState,
  useEffect,
} from "react";

import "../Styles/mmg.css";

import api from "../api";

import * as XLSX from "xlsx";

import jsPDF from "jspdf";

import autoTable from "jspdf-autotable";

import {
  toast,
} from "react-toastify";

import CountUp from "react-countup";

import {
  Landmark,
  Wallet,
  ArrowUpRight,
  Search,
  CalendarDays,
  Download,
  Plus,
  CheckCircle2,
  Clock3,
  X,
  ShieldCheck,
  User,
  CreditCard,
  Phone,
  ChevronDown,
} from "lucide-react";

import rcsLogo from "../assets/rcslogo.png";

const MMGTransactions = () => {

  const [
    loading,
    setLoading,
  ] = useState(true);

  const [
    transactions,
    setTransactions,
  ] = useState([]);

  const [
    showNewModal,
    setShowNewModal,
  ] = useState(false);

  const [
    showReceiveModal,
    setShowReceiveModal,
  ] = useState(false);

  const [
    showExportMenu,
    setShowExportMenu,
  ] = useState(false);

  const [
    selectedIds,
    setSelectedIds,
  ] = useState([]);

  const [
    searchTerm,
    setSearchTerm,
  ] = useState("");

  const [
    startDate,
    setStartDate,
  ] = useState("");

  const [
    endDate,
    setEndDate,
  ] = useState("");

  const [
    selectedMonth,
    setSelectedMonth,
  ] = useState(
    new Date()
      .toISOString()
      .slice(0, 7)
  );

  const [
    newTransaction,
    setNewTransaction,
  ] = useState({
    transId: "",
    type: "Agent",
    number: "",
    amount: "",
    adminCharge: "",
    date: "",
  });

  const [
    receiveDetails,
    setReceiveDetails,
  ] = useState({
    index: null,
    receivedBy: "",
    dateReceived: "",
    idType: "",
    idNumber: "",
  });

const [
  showTypeMenu,
  setShowTypeMenu,
] = useState(false);



  /* ========================================= */
  /* FETCH */
  /* ========================================= */

  useEffect(() => {

    fetchTransactions();

  }, []);

  const fetchTransactions =
    async () => {

      try {

        setLoading(true);

        const data =
          await api.getMMGTransactions();

        const normalized =
          data.map((tx) => ({
            id: tx.id,
            transId:
              tx.trans_id,
            type: tx.type,
            number:
              tx.number,
            amount:
              tx.amount,
            adminCharge:
              tx.admin_charge,
            net: tx.net,
            date:
              tx.transaction_date?.split(
                "T"
              )[0],
receivedBy:
  tx.received_by || "-",

dateReceived:
  tx.date_received
    ? tx.date_received.split(
        "T"
      )[0]
    : "-",

idType:
  tx.id_type || "",

idNumber:
  tx.id_number || "",

received:
  tx.received,
          }));

        setTransactions(
          normalized
        );

      } catch (error) {

        console.error(
          error
        );

      } finally {

        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };

  /* ========================================= */
  /* FORMAT */
  /* ========================================= */

  const formatCurrency = (
    value
  ) => {

    return `$${parseFloat(
      value || 0
    ).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 2,
      }
    )}`;
  };

  /* ========================================= */
  /* FILTER */
  /* ========================================= */

  const filteredTransactions =
    transactions.filter(
      (tx) => {

        const term =
          searchTerm.toLowerCase();

        const txDate =
          new Date(tx.date);

        const start =
          startDate
            ? new Date(
                startDate
              )
            : null;

        const end =
          endDate
            ? new Date(
                endDate
              )
            : null;

        const monthMatch =
          !selectedMonth ||
          tx.date?.slice(
            0,
            7
          ) ===
            selectedMonth;

        return (
          monthMatch &&
          (tx.transId
            ?.toString()
            .toLowerCase()
            .includes(
              term
            ) ||
            tx.number
              ?.toString()
              .toLowerCase()
              .includes(
                term
              ) ||
            tx.receivedBy
              ?.toLowerCase()
              .includes(
                term
              )) &&
          (!start ||
            txDate >=
              start) &&
          (!end ||
            txDate <= end)
        );
      }
    );

  /* ========================================= */
  /* STATS */
  /* ========================================= */

  const totalTransactions =
    filteredTransactions.length;

  const totalValue =
    filteredTransactions.reduce(
      (sum, tx) =>
        sum +
        parseFloat(
          tx.amount || 0
        ),
      0
    );

  const totalAdmin =
    filteredTransactions.reduce(
      (sum, tx) =>
        sum +
        parseFloat(
          tx.adminCharge ||
            0
        ),
      0
    );

  const pendingReceives =
    filteredTransactions
      .filter(
        (tx) => !tx.received
      )
      .reduce(
        (sum, tx) =>
          sum +
          parseFloat(
            tx.net || 0
          ),
        0
      );

  /* ========================================= */
  /* CREATE */
  /* ========================================= */

  const handleAddTransaction =
    async () => {

      const {
        transId,
        type,
        number,
        amount,
        adminCharge,
        date,
      } = newTransaction;

      if (
        !transId ||
        !type ||
        !number ||
        !amount ||
        !adminCharge ||
        !date
      ) {

        toast.warn(
          "Complete all transaction fields."
        );

        return;
      }

      const payload = {
        trans_id: transId,
        type,
        number,
        amount:
          parseFloat(
            amount
          ),
        admin_charge:
          parseFloat(
            adminCharge
          ),
        transaction_date:
          date,
      };

      const result =
        await api.createMMGTransaction(
          payload
        );

      if (result) {

        toast.success(
          "Transaction created successfully."
        );

        setShowNewModal(
          false
        );

        fetchTransactions();
      }
    };

  /* ========================================= */
  /* RECEIVE */
  /* ========================================= */

  const handleReceiveToggle =
    (index) => {

      setReceiveDetails({
        index,
        receivedBy: "",
        dateReceived: "",
        idType: "",
        idNumber: "",
      });

      setShowReceiveModal(
        true
      );
    };

  const confirmReceive =
    async () => {

      const {
        receivedBy,
        dateReceived,
        idType,
        idNumber,
        index,
      } = receiveDetails;

      if (
        !receivedBy ||
        !dateReceived ||
        !idType ||
        !idNumber
      ) {

        toast.warn(
          "Complete all receive fields."
        );

        return;
      }

      const id =
        filteredTransactions[
          index
        ].id;

      const success =
        await api.markMMGAsReceived(
          id,
          {
            received_by:
              receivedBy,
            date_received:
              dateReceived,
            id_type:
              idType,
            id_number:
              idNumber,
          }
        );

      if (success) {

        toast.success(
          "Transaction updated successfully."
        );

        setShowReceiveModal(
          false
        );

        fetchTransactions();
      }
    };

  /* ========================================= */
  /* EXPORT */
  /* ========================================= */

  const exportToExcel =
    () => {

      const worksheet =
        XLSX.utils.json_to_sheet(
          filteredTransactions
        );

      const workbook =
        XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "MMG"
      );

      XLSX.writeFile(
        workbook,
        "MMG_Transactions.xlsx"
      );
    };

  const exportToPDF =
    () => {

      const doc =
        new jsPDF();

      autoTable(doc, {
        head: [[
          "TransID",
          "Type",
          "Amount",
        ]],

        body:
          filteredTransactions.map(
            (tx) => [
              tx.transId,
              tx.type,
              tx.amount,
            ]
          ),
      });

      doc.save(
        "MMG_Transactions.pdf"
      );
    };

  /* ========================================= */
  /* LOADING */
  /* ========================================= */

  if (loading) {

    return (

      <div className="mmg-loading-screen">

        <div className="mmg-loader-container">

          <div className="mmg-loader-glow" />

          <div className="mmg-loader-spinner">

            <div className="mmg-loader-ring" />

            <div className="mmg-loader-ring-secondary" />

            <div className="mmg-loader-logo">

              <img
                src={rcsLogo}
                alt="RCS"
              />

            </div>

          </div>

          <div className="mmg-loader-text">

            <h2>
              Loading MMG
            </h2>

            <p>
              Preparing transaction
              records and balances...
            </p>

          </div>

        </div>

      </div>
    );
  }

  return (

    <div className="mmg-page">

      {/* HERO */}

      <div className="mmg-hero">

        <div className="mmg-hero-left">

          <div className="mmg-hero-pill">
            MOBILE MONEY
          </div>

          <h1>
            MMG Transaction Center
          </h1>

          <p>
            Monitor incoming
            transactions,
            settlements,
            admin charges and
            receives across
            the financial
            network.
          </p>

        </div>

        <div className="mmg-hero-card">

          <div className="mmg-live-dot" />

          <span>
            LIVE TRANSACTIONS
          </span>

<h2 className="mmg-hero-value">

  <span className="mmg-hero-currency">
    $
  </span>

  <CountUp
    end={totalValue}
    separator=","
    duration={2}
  />

</h2>

        </div>

      </div>
{/* STATS */}

<div className="mmgtracker-stats-grid">

  {/* TRANSACTIONS */}

  <div className="mmgtracker-stat-card">

    <div className="mmgtracker-stat-icon blue">

      <Wallet size={24} />

    </div>

    <div className="mmgtracker-stat-content">

      <span>
        Total Transactions
      </span>

      <h3 className="mmgtracker-stat-number">

        <CountUp
          end={totalTransactions}
          duration={2}
        />

      </h3>

    </div>

  </div>

  {/* TOTAL VALUE */}

  <div className="mmgtracker-stat-card">

    <div className="mmgtracker-stat-icon teal">

      <Landmark size={24} />

    </div>

    <div className="mmgtracker-stat-content">

      <span>
        Total Value
      </span>

      <h3 className="mmgtracker-stat-value">

        <span className="mmgtracker-currency">
          $
        </span>

        <CountUp
          end={totalValue}
          separator=","
          duration={2}
        />

      </h3>

    </div>

  </div>

  {/* ADMIN */}

  <div className="mmgtracker-stat-card">

    <div className="mmgtracker-stat-icon green">

      <ShieldCheck size={24} />

    </div>

    <div className="mmgtracker-stat-content">

      <span>
        Admin Charges
      </span>

      <h3 className="mmgtracker-stat-value">

        <span className="mmgtracker-currency">
          $
        </span>

        <CountUp
          end={totalAdmin}
          separator=","
          duration={2}
        />

      </h3>

    </div>

  </div>

  {/* PENDING */}

  <div className="mmgtracker-stat-card">

    <div className="mmgtracker-stat-icon orange">

      <Clock3 size={24} />

    </div>

    <div className="mmgtracker-stat-content">

      <span>
        Pending Receives
      </span>

      <h3 className="mmgtracker-stat-value">

        <span className="mmgtracker-currency">
          $
        </span>

        <CountUp
          end={pendingReceives}
          separator=","
          duration={2}
        />

      </h3>

    </div>

  </div>

</div>

      {/* TOOLBAR */}

      <div className="mmg-toolbar">

        <div className="mmg-search-box">

          <Search size={18} />

          <input
            type="text"
            placeholder="Search transactions..."
            value={
              searchTerm
            }
            onChange={(
              e
            ) =>
              setSearchTerm(
                e.target
                  .value
              )
            }
          />

        </div>

        <div className="mmg-toolbar-right">

          <div className="mmg-date-group">

            <CalendarDays size={16} />

            <input
              type="month"
              value={
                selectedMonth
              }
              onChange={(
                e
              ) =>
                setSelectedMonth(
                  e.target
                    .value
                )
              }
            />

          </div>

          <button
            className="mmg-export-btn"
            onClick={() =>
              setShowExportMenu(
                !showExportMenu
              )
            }
          >

            <Download size={16} />

            Export

          </button>

          {showExportMenu && (

            <div className="mmg-export-menu">

              <button
                onClick={
                  exportToExcel
                }
              >
                Excel
              </button>

              <button
                onClick={
                  exportToPDF
                }
              >
                PDF
              </button>

            </div>
          )}

          <button
            className="mmg-new-btn"
            onClick={() =>
              setShowNewModal(
                true
              )
            }
          >

            <Plus size={18} />

            New Transaction

          </button>

        </div>

      </div>

      {/* TRANSACTIONS */}

      <div className="mmg-card-grid">

        {filteredTransactions.map(
          (tx, i) => (

            <div
              key={tx.id}
              className={`mmg-transaction-card ${
                tx.received
                  ? "received"
                  : ""
              }`}
            >

              <div className="mmg-card-top">

                <div>

                  <span>
                    Transaction ID
                  </span>

                  <h4>
                    #
                    {
                      tx.transId
                    }
                  </h4>

                </div>

                <div
                  className={`mmg-type-badge ${
                    tx.type.toLowerCase()
                  }`}
                >
                  {tx.type}
                </div>

              </div>

              <div className="mmg-card-body">

                <div className="mmg-data-row">

                  <Phone size={15} />

                  <span>
                    +592
                    {
                      tx.number
                    }
                  </span>

                </div>

                <div className="mmg-data-row">

                  <Wallet size={15} />

                  <span>
                    {formatCurrency(
                      tx.amount
                    )}
                  </span>

                </div>

                <div className="mmg-data-row">

                  <ArrowUpRight size={15} />

                  <span>
                    Net:
                    {" "}
                    {formatCurrency(
                      tx.net
                    )}
                  </span>

                </div>

                <div className="mmg-data-row">

                  <CalendarDays size={15} />

                  <span>
                    {tx.date}
                  </span>

                </div>

              </div>

<div className="mmg-card-footer">

  <div
    className={`mmg-status-pill ${
      tx.received
        ? "success"
        : "pending"
    }`}
  >

    {tx.received ? (
      <>
        <CheckCircle2 size={15} />
        Received
      </>
    ) : (
      <>
        <Clock3 size={15} />
        Pending
      </>
    )}

  </div>

  {tx.received ? (

    <div className="mmg-received-details">

      <div className="mmg-received-line">

        <User size={13} />

        <span>
          {tx.receivedBy}
        </span>

      </div>

      <div className="mmg-received-line">

        <CalendarDays size={13} />

        <span>
          {tx.dateReceived}
        </span>

      </div>

      <div className="mmg-received-line">

        <CreditCard size={13} />

        <span>
          {tx.idType || "N/A"}
          {" • "}
          {tx.idNumber || "N/A"}
        </span>

      </div>

    </div>

  ) : (

    <button
      className="mmg-receive-btn"
      onClick={() =>
        handleReceiveToggle(i)
      }
    >
      Confirm
    </button>

  )}

</div>

            </div>
          )
        )}

      </div>

      {/* NEW MODAL */}

      {showNewModal && (

        <div className="mmg-modal-overlay">

          <div className="mmg-modal">

            <button
              className="mmg-close-btn"
              onClick={() =>
                setShowNewModal(
                  false
                )
              }
            >
              <X size={18} />
            </button>

            <div className="mmg-modal-header">

              <div className="mmg-modal-pill">
                NEW MMG
              </div>

              <h2>
                New Transaction
              </h2>

            </div>

            <div className="mmg-modal-grid">

              <div className="mmg-input-group">

                <label>
                  Transaction ID
                </label>

                <input
                  type="text"
                  value={
                    newTransaction.transId
                  }
                  onChange={(
                    e
                  ) =>
                    setNewTransaction(
                      {
                        ...newTransaction,
                        transId:
                          e
                            .target
                            .value,
                      }
                    )
                  }
                />

              </div>

              <div className="mmg-input-group">

                <label>
                  Type
                </label>

<div className="mmgtracker-type-dropdown">

  <button
    type="button"
    className="mmgtracker-type-trigger"
    onClick={() =>
      setShowTypeMenu(!showTypeMenu)
    }
  >

    <span>
      {newTransaction.type}
    </span>

    <ChevronDown size={16} />

  </button>

  {showTypeMenu && (

    <div className="mmgtracker-type-menu">

      {[
        "Agent",
        "Subscriber",
        "Bank",
      ].map((option) => (

        <button
          key={option}
          type="button"
          className={`mmgtracker-type-option ${
            newTransaction.type === option
              ? "active"
              : ""
          }`}
          onClick={() => {

            setNewTransaction({
              ...newTransaction,
              type: option,
            });

            setShowTypeMenu(false);

          }}
        >

          {option}

        </button>
      ))}

    </div>
  )}

</div>

              </div>

              <div className="mmg-input-group">

                <label>
                  Number
                </label>

<div className="mmg-phone-input">

  <span>+592</span>

  <input
    type="number"
    placeholder="6234567"
    value={newTransaction.number}
    onChange={(e) =>
      setNewTransaction({
        ...newTransaction,
        number: e.target.value,
      })
    }
  />

</div>

              </div>

              <div className="mmg-input-group">

                <label>
                  Amount
                </label>

                <input
                  type="number"
                  value={
                    newTransaction.amount
                  }
                  onChange={(
                    e
                  ) =>
                    setNewTransaction(
                      {
                        ...newTransaction,
                        amount:
                          e
                            .target
                            .value,
                      }
                    )
                  }
                />

              </div>


{/* ADMIN CHARGE */}

<div className="mmg-input-group">

  <label>
    Admin Charge
  </label>

  <input
    type="number"
    placeholder="Enter admin charge"
    value={newTransaction.adminCharge}
    onChange={(e) =>
      setNewTransaction({
        ...newTransaction,
        adminCharge: e.target.value,
      })
    }
  />

</div>

{/* TRANSACTION DATE */}

<div className="mmg-input-group">

  <label>
    Transaction Date
  </label>

  <input
    type="date"
    value={newTransaction.date}
    onChange={(e) =>
      setNewTransaction({
        ...newTransaction,
        date: e.target.value,
      })
    }
  />

</div>


            </div>

            <div className="mmg-modal-footer">

              <button
                className="mmg-cancel-btn"
                onClick={() =>
                  setShowNewModal(
                    false
                  )
                }
              >
                Cancel
              </button>

              <button
                className="mmg-submit-btn"
                onClick={
                  handleAddTransaction
                }
              >
                Create Transaction
              </button>

            </div>

          </div>

        </div>
      )}


{/* RECEIVE MODAL */}

{showReceiveModal && (

  <div className="mmg-modal-overlay">

    <div className="mmg-modal">

      <button
        className="mmg-close-btn"
        onClick={() =>
          setShowReceiveModal(false)
        }
      >
        <X size={18} />
      </button>

      <div className="mmg-modal-header">

        <div className="mmg-modal-pill">
          CONFIRM RECEIVE
        </div>

        <h2>
          Receive Transaction
        </h2>

      </div>

      <div className="mmg-modal-grid">

        {/* RECEIVED BY */}

        <div className="mmg-input-group">

          <label>
            Received By
          </label>

          <input
            type="text"
            placeholder="Enter receiver name"
            value={receiveDetails.receivedBy}
            onChange={(e) =>
              setReceiveDetails({
                ...receiveDetails,
                receivedBy: e.target.value,
              })
            }
          />

        </div>

        {/* DATE */}

        <div className="mmg-input-group">

          <label>
            Date Received
          </label>

          <input
            type="date"
            value={receiveDetails.dateReceived}
            onChange={(e) =>
              setReceiveDetails({
                ...receiveDetails,
                dateReceived: e.target.value,
              })
            }
          />

        </div>

        {/* ID TYPE */}

        <div className="mmg-input-group">

          <label>
            ID Type
          </label>

          <select
            value={receiveDetails.idType}
            onChange={(e) =>
              setReceiveDetails({
                ...receiveDetails,
                idType: e.target.value,
              })
            }
          >

            <option value="">
              Select ID
            </option>

            <option value="NID">
              NID
            </option>

            <option value="Passport">
              Passport
            </option>

            <option value="License">
              License
            </option>

          </select>

        </div>

        {/* ID NUMBER */}

        <div className="mmg-input-group">

          <label>
            ID Number
          </label>

          <input
            type="text"
            placeholder="Enter ID number"
            value={receiveDetails.idNumber}
            onChange={(e) =>
              setReceiveDetails({
                ...receiveDetails,
                idNumber: e.target.value,
              })
            }
          />

        </div>

      </div>

      <div className="mmg-modal-footer">

        <button
          className="mmg-cancel-btn"
          onClick={() =>
            setShowReceiveModal(false)
          }
        >
          Cancel
        </button>

        <button
          className="mmg-submit-btn"
          onClick={confirmReceive}
        >
          Confirm Receive
        </button>

      </div>

    </div>

  </div>
)}


    </div>
  );
};

export default MMGTransactions;